import { ApplicationError } from './application.error';

// Non-Error thrown values are legal in JS, but code that triggers this error
// should be refactored to throw Error instances or typed application errors.
export class UnknownApplicationError extends ApplicationError {
  constructor(message: string, originalError: any = null) {
    super(
      'UnknownApplicationError',
      message,
      'We hit an unexpected application error. Please contact support if the problem continues.',
      originalError
    );
  }
}
